import { useEffect, useState } from 'react';
import { auth } from '../services/auth';
import api from '../services/api';

export const useSession = () => {
  const [session, setSession] = useState<any>(undefined);

  useEffect(() => {
    const token = auth.getToken();

    if (!token) {
      setSession(null);
      return;
    }

    api
      .get(`/sessions/${token}`)
      .then(setSession)
      .catch(() => setSession(null));
  }, []);

  return session;
};
